// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3oKhY","legacyBtn":"MutateMid_legacyBtn__RT_VF"};